import { Grid, Typography } from "@mui/material";
import { Screen } from "../../../main/components/screen/Screen";
import { Accordion } from "../../../main/components/accordion/Accordion";
import CardDownload from "../components/CardDownload";
import { useEffect, useState } from "react";
import Loading from "../../../main/components/Loading";
import { faqs } from "../components/FaqList";
import EmptyStateNotFound from "../../clients/components/EmptyState";
import { faqApi } from "../../../services/api";
import BaseButton from "../../../main/components/BaseButton";
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import { NewCalledModal } from "../components/NewCalledModal";

export default function Faq() {
  const [showFaqDetailsAccordion, setShowFaqDetailsAccordion] = useState<
    boolean[]
  >(Array(faqs.length).fill(false));

  const toggleFaqDetailsAccordion = (index: number) => {
    const newShowFaqDetailsAccordion = [...showFaqDetailsAccordion];
    newShowFaqDetailsAccordion[index] = !newShowFaqDetailsAccordion[index];
    setShowFaqDetailsAccordion(newShowFaqDetailsAccordion);
  };
  const [faqPdfUrl, setFaqPdfUrl] = useState<string | null>(null);
  const [
    preventiveMaintenanceProcedurePdfUrl,
    setPreventiveMaintenanceProcedurePdfUrl,
  ] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const faqDownloadResponse = await faqApi.getDownloadFaqRop();
        if (
          faqDownloadResponse &&
          faqDownloadResponse.data &&
          faqDownloadResponse.data.manualPdfUrl
        ) {
          setFaqPdfUrl(faqDownloadResponse.data.manualPdfUrl);
        } else {
          console.error("Erro ao baixar o PDF da FAQ:", faqDownloadResponse);
        }

        const preventiveMaintenanceProcedureDownloadResponse =
          await faqApi.getDownloadFaqRop();
        if (
          preventiveMaintenanceProcedureDownloadResponse &&
          preventiveMaintenanceProcedureDownloadResponse.data &&
          preventiveMaintenanceProcedureDownloadResponse.data
            .procedimentoManutencaoPreventivaUrl
        ) {
          setPreventiveMaintenanceProcedurePdfUrl(
            preventiveMaintenanceProcedureDownloadResponse.data
              .procedimentoManutencaoPreventivaUrl
          );
        } else {
          console.error(
            "Erro ao baixar o PDF do Procedimento de Manutenção Preventiva:",
            preventiveMaintenanceProcedureDownloadResponse
          );
        }
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const getDownloadFaq = () => {
    if (faqPdfUrl) {
      downloadPdf(faqPdfUrl, "manual-portal-rop.pdf");
    } else {
      console.error("Erro ao baixar o PDF Manual Portal Rop.");
    }
  };

  const getDownloadPreventiveMaintenanceProcedure = () => {
    if (preventiveMaintenanceProcedurePdfUrl) {
      downloadPdf(
        preventiveMaintenanceProcedurePdfUrl,
        "procedimento-manutencao-preventiva-rop.pdf"
      );
    } else {
      console.error(
        "Erro ao baixar Procedimento de Manutenção Preventiva ainda não foi carregada."
      );
    }
  };

  const downloadPdf = (url: string, fileName: string) => {
    const downloadButton = document.createElement("a");
    downloadButton.href = url;
    downloadButton.download = fileName;
    downloadButton.click();
  };

  const [openNewCalledModal, setOpenNewCalledModal] = useState(false);

  const handleCloseNewCalledModal = () => {
    setOpenNewCalledModal(false);
  };

  return (
    <>
      <Screen.Root>
        {loading ? (
          <>
            <Screen.Container>
              <Loading />
            </Screen.Container>
          </>
        ) : (
          <>
            <Screen.Header sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "400",
                  paddingTop: "15px",
                  paddingBottom: "15px",
                }}
              >
                FAQ
              </Typography>
              <Grid>
                <BaseButton
                  onClick={() => setOpenNewCalledModal(true)}
                  sx={{ height: "35px" }}
                  title="Criar Chamado"
                  startIcon={<AddIcCallIcon />}
                />
              </Grid>
            </Screen.Header>
            <Screen.Container>
              {/* box para baixar pdf */}

              <Typography sx={{ margin: "5% 0% 2% 0%" }}>
                Perguntas Frequentes
              </Typography>
              {faqs && faqs.length > 0 ? (
                // faqs.map((faq, index) => (
                //   <>
                //     <Accordion.Root key={index} sx={{ width: "80%" }}>
                //       <>
                //         <Accordion.Header
                //           toggleDetails={() => toggleFaqDetailsAccordion(index)}
                //           showDetails={showFaqDetailsAccordion[index]}
                //           title={faq.question}
                //           typographySx={{
                //             fontSize: { xs: "13px", sm: "16px" },
                //             width: "50%",
                //             textAlign: "left",
                //           }}
                //         />
                //         <Accordion.Content
                //           showDetails={showFaqDetailsAccordion[index]}
                //           sx={{ maxHeight: "400px", overflow: "auto" }}
                //         >
                //           <Typography
                //             sx={{
                //               display: "flex",
                //               alignItems: "left",
                //               fontSize: "13px",
                //             }}
                //           >
                //             {faq.answer}
                //           </Typography>
                //         </Accordion.Content>
                //       </>
                //     </Accordion.Root>
                //   </>
                // ))
                faqs.map((faq, index) => (
                  <Accordion.Root key={index} sx={{ width: "80%" }}>
                    <>
                      <Accordion.Header
                        toggleDetails={() => toggleFaqDetailsAccordion(index)}
                        showDetails={showFaqDetailsAccordion[index]}
                        title={faq.question}
                        typographySx={{
                          fontSize: { xs: "13px", sm: "16px" },
                          width: "50%",
                          textAlign: "left",
                        }}
                      />
                      <Accordion.Content
                        showDetails={showFaqDetailsAccordion[index]}
                        sx={{ maxHeight: "400px", overflow: "auto" }}
                      >
                        <Typography
                          sx={{
                            display: "flex",
                            alignItems: "left",
                            fontSize: "13px",
                          }}
                        >
                          {faq.answer}
                        </Typography>
                      </Accordion.Content>
                    </>
                  </Accordion.Root>
                ))
              ) : (
                <EmptyStateNotFound title="Não foi possível carregar a FAQ." />
              )}
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  paddingTop: 5,
                }}
              >
                <Grid item md={6} sm={12}>
                  <CardDownload
                    label="Clique aqui para baixar o documento com todas as dúvidas descritas."
                    tooltipText="Baixar PDF da Faq"
                    onClick={getDownloadFaq}
                  // onClick={() =>
                  //   handleDownload(faqPdfUrl || "", "manual-portal-rop.pdf")
                  // }
                  />
                </Grid>
                <Grid item md={6} sm={12}>
                  <CardDownload
                    label="Clique aqui para baixar o documento de Procedimento de Manutenção Preventiva."
                    tooltipText="PDF Procedimento de Manutenção Preventiva"
                    onClick={getDownloadPreventiveMaintenanceProcedure}
                  // onClick={() =>
                  //   handleDownload(
                  //     preventiveMaintenanceProcedurePdfUrl || "",
                  //     "procedimento-manutencao-preventiva-rop.pdf"
                  //   )
                  // }
                  />
                </Grid>
              </Grid>
            </Screen.Container>
          </>
        )}
      </Screen.Root>
      <NewCalledModal
        onCancel={handleCloseNewCalledModal}
        open={openNewCalledModal}
        onClose={handleCloseNewCalledModal}
      />
    </>
  );
}
